<template>
    <canvas ref="chart"></canvas>
</template>

<script>
    import Chart from 'chart.js'
    export default {
        name: "ChartJs",
        props: {
            type: {
                type: String,
                default: 'bar',
                validator: v =>  /(bar|line|radar|pie|doughnut|polarArea|bubble|scatter|area|mixed)/gi.test(v)
            },
            data: {
                type: Object
            },
            options: {
                type: Object
            },
            width: {
                type: String
            },
            height: {
                type: String
            }
        },
        data() {
            return {
                chart: null,
                config: {
                    type: this.type,
                    data: this.data,
                    options: this.options
                }
            }
        },
        mounted() {
            if (this.width) this.$refs.chart.width = this.width;
            if (this.height) this.$refs.chart.height = this.height;

            this.chart = new Chart(this.$refs.chart, this.config);
        },
        watch: {
            data(newVal) {
                this.config.data = newVal;
                if (this.chart)
                    this.chart.update();

            }
        }
    }
</script>
